import axios from 'axios';

export const checkAuthStatus = async () => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_BACK_URL}/identity/auth/me`, {}, { withCredentials: true, headers:{"x-reqtype":"admin"} });
    return response.data;
  } catch (error) {
    console.error('Ошибка проверки статуса аутентификации: ', error.message);
    return false;
  }
};

export async function checkLogin(username, password) {
  try {
    const res = await axios.post(`${process.env.REACT_APP_BACK_URL}/identity/auth/signin`, { username, password }, { withCredentials: true, headers:{"x-reqtype":"admin"} });
    return res.request?.status;
  } catch (err) {
    console.log(`error status: ${err.request?.status}`);
    return err.request?.status;
  }
};

export async function checkLogout() {
  try {
    const res = await axios.post(`${process.env.REACT_APP_BACK_URL}/identity/auth/logout`, {}, { withCredentials: true, headers:{"x-reqtype":"admin"} });
    return res.request?.status;
  } catch (err) {
    console.log(`error status: ${err.request?.status}`);
    return err.request?.status;
  }
};
